import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router";

import { showSnackbar } from "@/store/reducers/app";

import PropTypes from "prop-types";

export default function AuthCatch({ message }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showSnackbar(message));
  }, [dispatch, message]);

  return <Navigate to="/" replace />;
}

AuthCatch.propTypes = {
  message: PropTypes.string,
};
